function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import React, { useState } from 'react';
import { FormattedMessage } from 'react-intl';
import cn from 'classnames';
import Cropper from 'react-easy-crop';
import ReactSlider from 'react-slider';
import formMessages from 'components/Form/messages';
import { CROP_BORDER, CROP_SIDE, CROP_SIZE, CONTAINER_SIDE, MAX_ZOOM } from '../variables';
import styles from '../AvatarCropModal.pcss';
const AvatarCrop = ({ imageSrc, rotation, isRound, setCroppedAreaPixels, setRotation })=>{
    const [crop, setCrop] = useState({
        x: 0,
        y: 0
    });
    const [zoom, setZoom] = useState(1);
    const [minZoom, setMinZoom] = useState(1);
    const [maxZoom, setMaxZoom] = useState(3);
    const onCropComplete = (croppedArea, croppedPixels)=>{
        setCroppedAreaPixels(croppedPixels);
    };
    const onMediaLoaded = (mediaSize)=>{
        // Adapt zoom based on media size to fit max height
        const { height, width, naturalHeight, naturalWidth } = mediaSize;
        const mediaSide = naturalHeight < naturalWidth ? height : width;
        const mediaZoom = CROP_SIDE / mediaSide;
        setZoom(mediaZoom);
        setMinZoom(mediaZoom);
        setMaxZoom(MAX_ZOOM - 1 + mediaZoom);
    };
    const onSlide = (value)=>{
        const newZoom = minZoom + (MAX_ZOOM - 1) * value / 100;
        setZoom(newZoom);
    };
    return /*#__PURE__*/ _jsxs(_Fragment, {
        children: [
            /*#__PURE__*/ _jsx("p", {
                className: "text--paragraph mb-6",
                children: /*#__PURE__*/ _jsx(FormattedMessage, _object_spread({}, formMessages.uploaderMessages.infos.adjust))
            }),
            /*#__PURE__*/ _jsx("div", {
                className: cn(styles.container, {
                    [styles['container--round']]: isRound
                }),
                style: {
                    width: CONTAINER_SIDE,
                    height: CONTAINER_SIDE,
                    borderWidth: CROP_BORDER
                },
                children: /*#__PURE__*/ _jsx("div", {
                    className: styles.cropContainer,
                    style: CROP_SIZE,
                    children: /*#__PURE__*/ _jsx(Cropper, {
                        image: imageSrc,
                        crop: crop,
                        cropSize: CROP_SIZE,
                        cropShape: isRound ? 'round' : 'rect',
                        aspect: 1,
                        rotation: rotation,
                        zoom: zoom,
                        minZoom: minZoom,
                        maxZoom: maxZoom,
                        onCropChange: setCrop,
                        onRotationChange: setRotation,
                        onCropComplete: onCropComplete,
                        onZoomChange: setZoom,
                        onMediaLoaded: onMediaLoaded
                    })
                })
            }),
            /*#__PURE__*/ _jsx("div", {
                className: styles.sliderContainer,
                style: {
                    width: CROP_SIDE
                },
                children: /*#__PURE__*/ _jsx(ReactSlider, {
                    className: "horizontal-slider",
                    thumbClassName: "slider-thumb",
                    trackClassName: "slider-track",
                    // eslint-disable-next-line @typescript-eslint/no-explicit-any
                    renderThumb: (props)=>/*#__PURE__*/ _jsx("div", _object_spread({}, props)),
                    value: (zoom - minZoom) * 100 / (MAX_ZOOM - 1),
                    onChange: onSlide
                })
            })
        ]
    });
};
export default AvatarCrop;
